import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  DependentFieldPicker,
  DependentFieldPickerSchema,
} from './DependentFieldPicker';

export const DependentFieldPickerExtension = FormFieldBlueprint.make({
  name: 'DependentFieldPicker',
  params: {
    field: async () =>
      createFormField({
        name: 'DependentFieldPicker',
        component: DependentFieldPicker,
        schema: DependentFieldPickerSchema,
      }),
  },
});
